(() => {
  const scope = document.querySelector('.product-info');
  if (!scope) return;
  let frame = 0;
  let applying = false;
  const panel = scope.querySelector('[data-ow-initial-heating]');
  if (!panel) return;
  const bindPanel = () => {
    panel.addEventListener('click', event => {
      const input = event.target.closest('.ow-heating-choice')?.querySelector('input');
      if (!input) return;
      if (input.disabled) {
        event.preventDefault();
        return;
      }
      if (event.target === input) return;
      event.preventDefault();
      input.focus({ preventScroll: true });
      input.click();
    });
    panel.addEventListener('change', event => {
      if (event.target.matches('input[name="ow-heating-choice"]')) choose(event.target.value);
    });
  };
  const memory = {};
  const rows = [...panel.querySelectorAll('.ow-heating-choice')].map(row => ({
    key: row.dataset.heating,
    input: row.querySelector('input'),
    price: row.querySelector('.ow-heating-price')
  }));
  const warning = panel.querySelector('.ow-heating-warning');
  const voltage = panel.querySelector('.ow-heating-voltage');
  const error = panel.querySelector('.ow-heating-error');
  const unavailableText = panel.querySelector('[data-unavailable]').textContent;
  const noExtraText = panel.querySelector('[data-no-extra]').textContent;
  const setText = (el, text) => { if (el.textContent !== text) el.textContent = text; };
  const cards = () => {
    const root = scope.querySelector('#clgqvsfydmb8, #clhvfmwa5ak7');
    return {
      root,
      wooden: root?.querySelector('.cl-po--option[data-option="Wooden handle"]'),
      electric: root?.querySelector('.cl-po--option[data-option="Add electric heater"]')
    };
  };
  const controls = () => {
    const c = cards();
    return { ...c,
      yes: c.wooden?.querySelector('input[value="Wooden handle"]'),
      no: c.wooden?.querySelector('input[value="No wooden handle needed"]'),
      heater: c.electric?.querySelector('input[value="Yes"]')
    };
  };
  const oversized = () => [...scope.querySelectorAll('.variant-picker__option')]
    .filter(el => /height|width|size/i.test(el.querySelector('legend')?.textContent || ''))
    .some(el => Number((el.querySelector('button.select')?.textContent || '').match(/([\d.]+)\s*cm/i)?.[1] || 0) > 5);
  const tilePrice = input => {
    const text = input?.closest('.cl-po--swatch-item')?.querySelector('.cl-po--swatch-text')?.textContent || '';
    return text.match(/\(\s*\+\s*(.*?)\s*\)/)?.[1] || '';
  };
  const totalPrice = (a, b) => {
    const numeric = value => Number((value.match(/[\d][\d,.]*/)?.[0] || '').replace(/,/g, ''));
    if (!a || !b) return '';
    const sum = numeric(a) + numeric(b);
    const sample = a.match(/[\d][\d,.]*/)?.[0];
    if (!sample || !Number.isFinite(sum)) return `${a} + ${b}`;
    const decimals = sample.includes('.') ? sample.split('.').pop().length : 0;
    return a.replace(sample, sum.toLocaleString('en-GB', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }));
  };
  const selected = c => c.yes?.checked ? (c.heater?.checked ? 'both' : 'flame') : c.no?.checked ? (c.heater?.checked ? 'electric' : 'head') : '';
  const choose = value => {
    if (applying) return;
    const c = controls();
    if (!c.yes || !c.no || (['electric', 'both'].includes(value) && (oversized() || !c.heater || c.heater.disabled))) { schedule(); return; }
    applying = true;
    const wood = ['flame', 'both'].includes(value);
    const heat = ['electric', 'both'].includes(value);
    const target = wood ? c.yes : c.no;
    if (!target.checked) target.click();
    const heater = controls().heater;
    if (heater && heater.checked !== heat) {
      if (heat) heater.click();
      else heater.closest('.cl-po--swatch-item').querySelector('.cl-po--swatch')?.click();
    }
    applying = false;
    error.hidden = true;
    schedule();
  };
  const observer = new MutationObserver(schedule);
  function sync() {
    frame = 0;
    const c = controls();
    const unavailable = oversized();
    if (!c.yes || !c.no || (!c.heater && !unavailable)) return;
    observer.disconnect();
    try {
      c.wooden.classList.add('ow-heating-native');
      c.electric?.classList.add('ow-heating-native');
      c.root.querySelectorAll('.ow-choice-placeholder[data-ow-choice="electric-heater"]').forEach(el => el.classList.add('ow-heating-native'));
      memory.flamePrice = tilePrice(c.yes) || memory.flamePrice;
      memory.electricPrice = tilePrice(c.heater) || memory.electricPrice;
      const choice = selected(c);
      rows.forEach(({ key, input, price: priceLabel }) => {
        input.checked = choice === key;
        input.disabled = ['electric', 'both'].includes(key) && (unavailable || !c.heater || c.heater.disabled);
        const price = key === 'flame' ? memory.flamePrice : key === 'electric' ? memory.electricPrice : totalPrice(memory.flamePrice, memory.electricPrice);
        setText(priceLabel, input.disabled ? unavailableText : key === 'head' ? noExtraText : price ? `+ ${price}` : '');
      });
      warning.hidden = !unavailable;
      voltage.hidden = unavailable;
      error.hidden = !c.wooden.classList.contains('ow-choice-needs-attention');
      if (!panel.hasAttribute('data-ow-heating-ready')) {
        panel.setAttribute('data-ow-heating-ready', '');
        window.dispatchEvent(new CustomEvent('ow:heating-ready'));
      }
    } finally {
      observer.observe(scope, { childList: true, subtree: true, characterData: true });
    }
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(sync); }
  bindPanel();
  observer.observe(scope, { childList: true, subtree: true, characterData: true });
  scope.addEventListener('change', schedule);
  document.addEventListener('variant:change', schedule);
  window.addEventListener('options:rendered', schedule);
  schedule();
})();


